import React, {useEffect} from "react";
import "./InterviewerUpcoming.css";
import UpcomingInterview from "./cards/UpcomingInterview";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import DatePicker from "react-date-picker";
import Snackbar from "@mui/material/Snackbar";
import Slide from "@mui/material/Slide";
import axios from "axios";
import { Helmet } from "react-helmet";
import Navbar from "./Navbar";
import NavbarStudents from "../Dashboard/Navbarlogedin";
import NavbarProfessionals from "../Interviewer/NavbarInterviewer";
import Footer from "../Home/Footer";

const InterviewerUpcoming = () => {
  const user = JSON.parse(localStorage.getItem("isIAuthenticated"));
  const [cards, setCards] = React.useState();
  useEffect(() => {
    setTimeout(() => window.scrollTo(0, 0), 100);
  }, []);
  function TransitionRight(props) {
    setDate(null);
    return <Slide {...props} direction="right" />;
  }
  const [date, setDate] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [transition, setTransition] = React.useState(undefined);
  const handleClick = (Transition) => () => {
    setTransition(() => Transition);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  React.useEffect(() => {
    async function fetchData() {
      const req = await axios.get(`${process.env.REACT_APP_SERVER_URL}/api/get`);
      setCards(req.data);
      console.log(req.data);
    }
    fetchData();
  }, []);
  return (
    <>
      {!user?.role ? <Navbar /> : null}
      {user?.role === "Student" ? <NavbarStudents /> : null}
      {user?.role === "Interviewer" ? <NavbarProfessionals /> : null}
      <Helmet>
        <title>Interwiu | Upcoming Interviews</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <div className="upcoming-interview interviews">
        {/* <div className="interviews-container"></div> */}
        <div
          className="flex justify-center items-center my-4 mx-3 w-auto"
          id="head"
        >
          <h2 className="interview-head text-2xl font-medium">
            Upcoming Interviews (12)
          </h2>
        </div>
        <div className="interview-cont">
          <div className="flex justify-between mx-8">
            <div>
              Showing the results for {date ? date.toDateString() : "all days"}
            </div>
            <div className="flex gap-2">
              <label htmlFor="date">Filter by Date: </label>
              <DatePicker
                onChange={(newValue) => {
                  setDate(newValue);
                }}
                value={date}
              />
            </div>
          </div>
          <div className="interviews-list">
            {cards?.map((result) => (
              <>
                <UpcomingInterview
                  name={result.fromname}
                  desg={result.profile}
                  slot={result.slot}
                  id={result._id}
                  status={result.status}
                  payment={result.payment}
                />
              </>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default InterviewerUpcoming;
